import bookingStatus from '../../common/bookingStatus.js'

/*
 * Booking colours.
 *
 * Was an Angular factory taking the `BookingStatus` constant (step 34 of #614). It has no other
 * dependencies, so it is a plain module now and imports the statuses directly rather than having
 * them injected.
 */
var colours = {}
colours[bookingStatus.HOLD] = { primary: '#ffbe4e', secondary: '#ffcd79' } // amber
colours[bookingStatus.CONFIRMED] = { primary: '#009d7e', secondary: '#3ac0a6' } // green
colours[bookingStatus.COMPLETED] = { primary: '#f74b63', secondary: '#f97688' } //red
colours[bookingStatus.ADMIN] = { primary: '#3062ac', secondary: '#2a61b2' } // blue
colours[bookingStatus.EXTERNAL] = { primary: '#274472', secondary: '#3798a9' } // blue
colours[bookingStatus.UNFUCKABLE] = { primary: '#ffb435', secondary: '#975F00' } // poo-brown
colours[bookingStatus.QUOTING] = { primary: '#ffffff', secondary: '#6a6a6a' } // grey

const colourService = {
  getColour: function (booking) {
    var colour = colours[booking.status]
    if (booking.criticalTask) {
      colour = { primary: '#e9dee4', secondary: '#e898e6' } //purple
    }
    return colour
  },
}

export default colourService
